// My Analytics component
import React from 'react';
import { Location } from '@reach/router';
import ReactGA from 'react-ga';
import { ENVIRONMENT } from './constants';

const Analytics = ({ children, id }: { children: JSX.Element; id: string }) => {
  if (ENVIRONMENT !== 'production' || typeof document === 'undefined' || !id) {
    return children;
  }
  ReactGA.initialize(id);
  return (
    <Location>
      {({ location }) => {
        console.log('GA: ', location.pathname, location.search, location.hash);
        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname + location.search + location.hash);
        return children;
      }}
    </Location>
  );
};

export default Analytics;
